import type { MessageTemplateContextShape } from '@post-office/shared-contracts/types';

import { type SpotlightTourMode } from './components/types';

export const SPOTLIGHT_DISMISS_EVENT = 'dismissSpotlightTour';

/**
 * If you update this run yarn generate:all to update the system
 * with your new MessageTemplateContext
 */
/**
 * For details on each variant, see
 * https://hello.atlassian.net/wiki/spaces/Growth/pages/4591780730/TWC+Welcome+Modal+Content+Variants+Overview
 */
export type MessageTemplateContext = MessageTemplateContextShape<{
	variant: 'twc' | 'loom' | 'var3' | 'var4' | 'var5' | 'var6' | 'none';
	appOneName?: string;
	appTwoName?: string;
	spotlightTourMode: SpotlightTourMode;
	cloudId?: string;
}>;
